export const BUDGET = "BUDGET";
export const BOT = "BOT";
export const POSITION_SETTINGS = "POSITIONSETTINGS";
export const PORTFOLIO = "PORTFOLIO";
export const SUCCESS = "SUCCESS";
export const SELECTION = "SELECTION";
export const STATUS = "STATUS";
export const POSITION = "POSITION";
export const UNFOLLOW = "UNFOLLOW";
